import { DefaultHandlerProvider } from 'relay-runtime';
import type { Handler, MutableRecordSource } from 'relay-runtime/lib/store/RelayStoreTypes';

import { DeleteEdgeHandler } from './deleteEdgeHandler';
import { createDeleteRecordHandler } from './deleteRecordHandler';

export function createRelayHandlerProvider(
	source: MutableRecordSource,
): (handle: string) => Handler {
	const DeleteRecordHandler = createDeleteRecordHandler(source);

	return (handle: string): Handler => {
		switch (handle) {
			case 'deleteEdge':
				return DeleteEdgeHandler;
			case 'deleteRecord':
				return DeleteRecordHandler;
			default:
				return DefaultHandlerProvider(handle);
		}
	};
}
